"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const Button_1 = tslib_1.__importDefault(require("@mui/material/Button"));
const Link_1 = tslib_1.__importDefault(require("../Link"));
/**
 * This component renders a {@link @mui/material.Button} wrapping a {@link Link} component and should be used for consistency accross pages.
 *
 * By default, the {@link Link} component is not underlined and do not change color on hover.
 * This can be overridden using `LinkProps`.
 *
 * When `target="_blank"` is provided as `LinkProps`, the "OpenInNew" icon is appended to the children.
 *
 * @example ### Basic example
 *
 * A basic rendering of this component where the url opens in the current context.
 *
 * ```jsx live
 * function(){
 *   const { ButtonLink } = MUI5;
 *   return (
 *     <ButtonLink LinkProps={{ href: "/does/not/exist"}} >
 *       My special case
 *     </ButtonLink>
 *   )
 * }
 * ```
 * @example ### Target blank
 *
 * If `target: '_blank'` is provided a icon is appended to indicate that this will open in a new context
 *
 * ```jsx live
 * function(){
 *  const { ButtonLink } = MUI5;
 *  return (
 *   <ButtonLink LinkProps={{ target: "_blank", href: "does/not/exist"}}>
 *     My special case
 *   </ButtonLink>
 *   )
 * }
 * ```
 */
const ButtonLink = ({ children, LinkProps, ...rest }) => (react_1.default.createElement(Button_1.default, { ...rest },
    react_1.default.createElement(Link_1.default, { underline: "none", changeColorOnHover: false, ...LinkProps }, children)));
exports.default = ButtonLink;
